import React from 'react'
import background from './../assets/kidney.png';

const Navbar = ({type}) => {
  if (type === 'login') {
    return (
      <div className='w-full px-2 bg-white flex flex-col items-center'>
        <h1 className='font-semibold text-5xl sm:text-4xl mt-10 py-2 md:text-5xl heading text-purple-800 text-center'>
          Rocket
        </h1>
        <img className='' style={{ width: '8%', height: 'auto' }} src={background} alt="Healing Kidneys Logo" />
      </div>
    )
  }else{
    return (
      <div className='w-full h-16 px-2 bg-white flex items-center'>
        <h1 className='font-semibold text-4xl sm:text-xl py-2 md:text-4xl heading text-purple-800 ml-auto'>
          Rocket
        </h1>
        <img style={{ width: '6%', height: '160%' }} src={background} alt="Healing Kidneys Logo" />
      </div>
    )
  }
}

export default Navbar